import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { FaSave, FaTimes } from 'react-icons/fa';
import ShafyorService from '../../services/ShafyorService';
import { toast } from 'react-toastify';

const ShafyorForm = ({ show, onHide, onSave, shafyor }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    prava_raqam: '',
    password: '',
    password_confirmation: ''
  });
  
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  // Initialize form when component mounts or when shafyor prop changes
  useEffect(() => {
    if (shafyor) {
      setIsEditMode(true);
      setFormData({
        name: shafyor.name || '',
        phone: shafyor.phone || '',
        email: shafyor.email || '',
        prava_raqam: shafyor.prava_raqam || '',
        password: '',
        password_confirmation: ''
      });
    } else {
      setIsEditMode(false);
      setFormData({
        name: '',
        phone: '',
        email: '',
        prava_raqam: '',
        password: '',
        password_confirmation: ''
      });
    }
    setErrors({});
  }, [shafyor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    // if (!formData.name) newErrors.name = 'Ism-sharifni kiriting';
    if (!formData.phone) newErrors.phone = 'Telefon raqamini kiriting';
    // if (!formData.email) newErrors.email = 'Elektron pochtani kiriting';
    // if (!formData.prava_raqam) newErrors.prava_raqam = 'Guvohnoma raqamini kiriting';
    
    // if (!isEditMode) {
    //   if (!formData.password) newErrors.password = 'Parolni kiriting';
    //   if (formData.password !== formData.password_confirmation) {
    //     newErrors.password_confirmation = 'Parollar mos emas';
    //   }
    // } else if (formData.password && formData.password !== formData.password_confirmation) {
    //   newErrors.password_confirmation = 'Parollar mos emas';
    // }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setLoading(true);
    
    try {
      const dataToSend = { ...formData };
      
      // If editing and password is empty, remove it from the data
      if (isEditMode && !dataToSend.password) {
        delete dataToSend.password;
        delete dataToSend.password_confirmation;
      }
      
      const response = await ShafyorService.createShafyor(dataToSend);
      
      if (response.success) {
        toast.success('Shafyor muvaffaqiyatli saqlandi');
        onSave(response.data);
        onHide();
      } else {
        // Handle server-side validation errors
        if (response.errors) {
          const serverErrors = {};
          Object.entries(response.errors).forEach(([field, messages]) => {
            serverErrors[field] = Array.isArray(messages) ? messages[0] : messages;
          });
          setErrors(serverErrors);
        } else {
          toast.error(response.message || 'Xatolik yuz berdi');
        }
      }
    } catch (error) {
      console.error('Error saving shafyor:', error);
      toast.error(error.message || 'Shafyorni saqlashda xatolik yuz berdi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered style={{zIndex: 9999}}>
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? 'Shafyorni tahrirlash' : 'Yangi shafyor qo\'shish'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label>Ism-sharif</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  isInvalid={!!errors.name}
                  placeholder="Ism-sharifni kiriting"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formPhone">
                <Form.Label>Telefon raqam <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  isInvalid={!!errors.phone}
                  placeholder="+998901234567"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.phone}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Elektron pochta</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                  placeholder="example@mail.com"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formPravaRaqam">
                <Form.Label>Guvohnoma raqami</Form.Label>
                <Form.Control
                  type="text"
                  name="prava_raqam"
                  value={formData.prava_raqam}
                  onChange={handleChange}
                  isInvalid={!!errors.prava_raqam}
                  placeholder="AA1234567"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.prava_raqam}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          
          {/*<Row>*/}
          {/*  <Col md={6}>*/}
          {/*    <Form.Group className="mb-3" controlId="formPassword">*/}
          {/*      <Form.Label>*/}
          {/*        {isEditMode ? 'Yangi parol' : 'Parol'} */}
          {/*        {!isEditMode && <span className="text-danger">*</span>}*/}
          {/*      </Form.Label>*/}
          {/*      <Form.Control*/}
          {/*        type="password"*/}
          {/*        name="password"*/}
          {/*        value={formData.password}*/}
          {/*        onChange={handleChange}*/}
          {/*        isInvalid={!!errors.password}*/}
          {/*        placeholder={isEditMode ? 'O\'zgartirish uchun yangi parol kiriting' : 'Parolni kiriting'}*/}
          {/*      />*/}
          {/*      <Form.Control.Feedback type="invalid">*/}
          {/*        {errors.password}*/}
          {/*      </Form.Control.Feedback>*/}
          {/*    </Form.Group>*/}
          {/*  </Col>*/}
          {/*  */}
          {/*  <Col md={6}>*/}
          {/*    <Form.Group className="mb-3" controlId="formPasswordConfirm">*/}
          {/*      <Form.Label>*/}
          {/*        {isEditMode ? 'Yangi parolni tasdiqlash' : 'Parolni tasdiqlash'} */}
          {/*        {!isEditMode && <span className="text-danger">*</span>}*/}
          {/*      </Form.Label>*/}
          {/*      <Form.Control*/}
          {/*        type="password"*/}
          {/*        name="password_confirmation"*/}
          {/*        value={formData.password_confirmation}*/}
          {/*        onChange={handleChange}*/}
          {/*        isInvalid={!!errors.password_confirmation}*/}
          {/*        placeholder="Parolni qayta kiriting"*/}
          {/*      />*/}
          {/*      <Form.Control.Feedback type="invalid">*/}
          {/*        {errors.password_confirmation}*/}
          {/*      </Form.Control.Feedback>*/}
          {/*    </Form.Group>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          
          {Object.keys(errors).length > 0 && (
            <Alert variant="danger" className="mt-3">
              Iltimos, barcha maydonlarni to'g'ri to'ldiring.
            </Alert>
          )}
        </Modal.Body>
        
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            <FaTimes className="me-1" /> Bekor qilish
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" size="sm" animation="border" role="status" aria-hidden="true" className="me-1" />
                Saqlanmoqda...
              </>
            ) : (
              <>
                <FaSave className="me-1" /> Saqlash
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ShafyorForm;
